module.exports = __webpack_public_path__ + "img/octa_store.2652b637.svg";